import { useTranslation } from '@klv/hooks/useTranslation';
import { camelCase } from 'lodash-es';

import * as styles from '../styles/statusIndicator.module.scss';

import { generateClassName } from '@klv/shared/utils/functions';

import type { IKlaviyoStatusIndicator } from '../types';


export const StaticKlaviyoStatusIndicator = ({
  className,
  indicator = null,
  status = null,
  ...props
}: IKlaviyoStatusIndicator) => {
  const { t } = useTranslation();
  const hiddenText = 'View details about Klaviyo’s status: ';

  if (!status) return null;

  return (
    <div className={generateClassName([className, 'klaviyoStatusIndicator', styles.klaviyoStatusIndicator])} {...props}>
      <a aria-label={`${hiddenText}${status} (opens in a new tab)`} className={styles.indicatorLink} href="https://status.klaviyo.com" rel="noreferrer" target="_blank">
        <div className={generateClassName([styles.indicator, indicator !== null && styles[indicator]])} />
        <div className={generateClassName([styles.statusText, 'p1', 'semibold'])}>
          <span className='visuallyHidden'>{hiddenText}</span>
          {t(`organisms_klaviyoStatusIndicator_status_${camelCase(status)}`) || ''}
        </div>
      </a>
    </div>
  );
};

export default StaticKlaviyoStatusIndicator;
